/* RESTAURENTA FX v2 (10/10/2026) : apparitions, mots un à un, compteurs, cadres néon, parallaxe 3D,
   halo de curseur, particules du héros, étincelles du cockpit, barre de lecture.
   Additif, sans dépendance. Aucun texte n'est modifié : les mots sont enveloppés dans des <span>, les compteurs
   remettent le libellé d'origine à la fin. Tout ce qui coûte (canvas, curseur, tilt) est réservé au bureau et
   mis en pause hors écran ou quand l'onglet est caché.
   v5 (18/10/2026) — correctif 1 « compteurs » : la valeur finale du HTML est la référence ; l'animation n'est
   qu'une surcouche, ne démarre que si l'onglet est visible, part de 70 % de la valeur (jamais de 0) et un
   garde-fou remet le libellé d'origine si les images ne suivent pas. Rien d'autre n'a changé. */
(function(){
  'use strict';
  var mq = function(q){ return window.matchMedia && window.matchMedia(q).matches; };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var desktop = mq('(min-width: 760px)');
  var fine = mq('(pointer: fine)');
  var hasIO = 'IntersectionObserver' in window;
  var $ = function(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  if (reduce) return; /* l'utilisateur a demandé moins d'animations : on ne fait rien du tout */
  document.documentElement.classList.add('rt-fx');

  /* ---------- 0. mots découpés (titres) ---------- */
  function splitWords(el, keepUnits, noClass){
    if (!el || el.getAttribute('data-fx-split')) return;
    el.setAttribute('data-fx-split', '1');
    var i = 0;
    var wrap = function(text){
      var frag = document.createDocumentFragment();
      text.split(/(\s+)/).forEach(function(part){
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
        var w = document.createElement('span'); w.className = 'rt-w';
        var wi = document.createElement('span'); wi.className = 'rt-wi'; wi.style.setProperty('--i', i++); wi.textContent = part;
        w.appendChild(wi); frag.appendChild(w);
      });
      return frag;
    };
    Array.prototype.slice.call(el.childNodes).forEach(function(n){
      if (n.nodeType === 3) { if (n.nodeValue.trim()) el.replaceChild(wrap(n.nodeValue), n); }
      else if (n.nodeType === 1 && n.tagName !== 'BR') {
        if (keepUnits && keepUnits.indexOf(n) >= 0 || n.children.length === 0 && n.textContent.trim().split(/\s+/).length === 1) {
          /* une unité insécable (ex. « Uber Eats ») : on l'enveloppe telle quelle */
          var w = document.createElement('span'); w.className = 'rt-w';
          var wi = document.createElement('span'); wi.className = 'rt-wi'; wi.style.setProperty('--i', i++);
          el.replaceChild(w, n); wi.appendChild(n); w.appendChild(wi);
        } else {
          /* élément avec plusieurs mots (ex. <em>Plus de commandes.</em>) : on découpe dedans */
          Array.prototype.slice.call(n.childNodes).forEach(function(c){ if (c.nodeType === 3 && c.nodeValue.trim()) n.replaceChild(wrap(c.nodeValue), c); });
        }
      }
    });
    if (!noClass) el.classList.add('rt-words');
  }

  /* ---------- 1. apparitions ---------- */
  var neonTargets = [];
  function reveal(){
    var targets = [];
    ['.rt-proofline__card', '.rt-cases__right', '.rt-method-grid', '.rt-checks', '.uh-chips', '.rt-performance__numbers', '.rt-dashboard-list', '.uh-ba__features', '.rt-form__grid'].forEach(function(sel){
      $(sel).forEach(function(el){ if (el.children.length > 1) { el.classList.add('rt-fx-stagger'); el.classList.remove('rt-reveal'); targets.push(el); } });
    });
    ['.rt-proofline__card', '.rt-form', '.rt-founder__card'].forEach(function(sel){ $(sel).forEach(function(el){ el.classList.add('rt-fx-neon'); var ring = document.createElement('i'); ring.className = 'rt-fx-neon__ring'; ring.setAttribute('aria-hidden', 'true'); ring.appendChild(document.createElement('b')); el.appendChild(ring); neonTargets.push(el); if (targets.indexOf(el) < 0) targets.push(el); }); });
    $('.rt-cs-title, .rt-heading').forEach(function(h){ splitWords(h); targets.push(h); });
    var h1 = document.querySelector('.uh-headline'); if (h1) splitWords(h1, $('.uh-ue', h1), true);
    $('.rt-reveal').forEach(function(el){ if (targets.indexOf(el) < 0) targets.push(el); });
    $('.rt-cs-underline, .rt-case__pct, .uh-ba__cols').forEach(function(el){ targets.push(el); });
    $('.rt-article-body figure, .rt-article-body .rt-callout, .rt-article-body .rt-callout-cta, .rt-article-body table').forEach(function(el){ targets.push(el); });

    var show = function(el){
      el.classList.add('is-visible'); el.classList.add('rt-fx-in');
      if (el.classList.contains('rt-fx-neon--once')) el.classList.add('rt-fx-neon-go');
      $('.rt-fx-neon--once', el).forEach(function(n, i){ n.style.setProperty('--nd', (i * 0.14).toFixed(2) + 's'); n.classList.add('rt-fx-neon-go'); });
      $('.rt-fx-line--once', el).forEach(function(n, i){ n.style.setProperty('--nd', (i * 0.12).toFixed(2) + 's'); n.classList.add('rt-fx-line-go'); });
      if (el.classList.contains('rt-proofline__card') || el.classList.contains('rt-performance__numbers') || el.classList.contains('rt-cases__right')) countersIn(el);
    };
    if (!hasIO) { targets.forEach(show); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
    targets.forEach(function(el){
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92 && r.bottom > 0) show(el); else io.observe(el);
    });
    /* cadres néon : animés seulement quand ils sont à l'écran */
    if (neonTargets.length) {
      var io2 = new IntersectionObserver(function(entries){ entries.forEach(function(e){ e.target.classList.toggle('rt-fx-paused', !e.isIntersecting); }); }, { threshold: 0 });
      neonTargets.forEach(function(el){ io2.observe(el); });
    }
  }

  /* ---------- 2. compteurs (v5, 18/10/2026) ----------
     Règle : le libellé écrit dans le HTML est la valeur de référence, toujours. L'animation est une surcouche :
     - elle ne démarre pas si l'onglet est caché (requestAnimationFrame ne tourne pas, le chiffre resterait figé) ;
     - elle part de 70 % de la valeur et monte vers 100 %, jamais de 0 (une capture à mi-course reste crédible) ;
     - un garde-fou (setTimeout) remet le libellé d'origine si les images ne suivent pas (appareil lent) ;
     - si l'onglet est caché pendant l'animation, le libellé d'origine est remis immédiatement ;
     - un nœud texte n'est animé qu'une seule fois, même s'il est atteint par deux sélecteurs imbriqués. */
  var NUM = /(\d{1,3}(?:[   ]\d{3})+|\d+)(?:([,.])(\d+))?/;
  function animateNumber(node){
    if (node.getAttribute('data-fx-done')) return;
    node.setAttribute('data-fx-done', '1');
    if (document.hidden) return; /* onglet caché : on garde la valeur finale telle quelle */
    var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null), tn = null, m = null;
    while (walker.nextNode()) { var mm = NUM.exec(walker.currentNode.nodeValue); if (mm) { tn = walker.currentNode; m = mm; break; } }
    if (!tn) return;
    /* un même nœud texte peut être atteint deux fois (ex. .rt-case__stat et le <b> qu'il contient) :
       on ne l'anime qu'une fois, sinon deux animations se disputent la valeur finale */
    if (tn.__rtFxSeen) return;
    tn.__rtFxSeen = true;
    var original = tn.nodeValue;
    var sep = (m[1].match(/[   ]/) || [' '])[0];
    var intPart = m[1].replace(/[   ]/g, '');
    var decimals = m[3] ? m[3].length : 0;
    var target = parseFloat(intPart + (m[3] ? '.' + m[3] : ''));
    if (!isFinite(target) || target === 0) return;
    var before = original.slice(0, m.index), after = original.slice(m.index + m[0].length);
    var dur = 1200, t0 = null, done = false, guard = null;
    var fmt = function(v){ var s = v.toFixed(decimals), parts = s.split('.'); var ip = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep); return ip + (decimals ? m[2] + parts[1] : ''); };
    var onHide = function(){ if (document.hidden) finish(); };
    var finish = function(){
      if (done) return; done = true;
      if (guard) clearTimeout(guard);
      document.removeEventListener('visibilitychange', onHide);
      tn.nodeValue = original; node.classList.add('rt-fx-counted');
    };
    var step = function(ts){
      if (done) return;
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      tn.nodeValue = before + fmt(target * (0.7 + 0.3 * e)) + after;
      if (p < 1) requestAnimationFrame(step); else finish();
    };
    document.addEventListener('visibilitychange', onHide);
    guard = setTimeout(finish, dur + 400); /* garde-fou : quoi qu'il arrive, la vraie valeur revient */
    tn.nodeValue = before + fmt(target * 0.7) + after;
    requestAnimationFrame(step);
  }
  function countersIn(root){
    $('.rt-proofline__item > b, .rt-performance__numbers b, .rt-case__stat, .rt-case__big, .rt-case__info b', root).forEach(function(el){
      if (/^[\s≈+×]*\d/.test(el.textContent)) animateNumber(el);
    });
  }

  /* ---------- 3. relief 3D : collage du héros, cartes clients, cadre du cockpit ---------- */
  function tilt3d(host, target, maxX, maxY, persp){
    if (!host || !target) return;
    var raf = null;
    host.addEventListener('mousemove', function(ev){
      var r = host.getBoundingClientRect();
      var x = (ev.clientX - r.left) / r.width - 0.5, y = (ev.clientY - r.top) / r.height - 0.5;
      host.classList.add('rt-fx-tilting'); target.classList.add('rt-fx-tilt');
      if (!raf) raf = requestAnimationFrame(function(){
        target.style.transform = 'perspective(' + persp + 'px) rotateX(' + (-y * maxX).toFixed(2) + 'deg) rotateY(' + (x * maxY).toFixed(2) + 'deg) translateZ(6px)';
        raf = null;
      });
    });
    host.addEventListener('mouseleave', function(){ host.classList.remove('rt-fx-tilting'); target.classList.remove('rt-fx-tilt'); target.style.transform = ''; });
  }
  function tilts(){
    if (!desktop || !fine) return;
    /* v4 : le héros est géré par heroDepth() (v3) ; le relief du grand dashboard est retiré (41 -> 58 images/s mesuré) */
    $('.rt-case').forEach(function(c){ tilt3d(c, c, 7, 9, 900); });
  }

  /* ---------- 4. halo et point qui suivent la souris ---------- */
  function cursor(){
    if (!desktop || !fine) return;
    var dot = document.createElement('div'); dot.className = 'rt-fx-dot';
    document.body.appendChild(dot);
    var halo = { style: {}, classList: { add: function(){}, remove: function(){} } }; /* halo retiré (v4) */
    var tx = 0, ty = 0, hx = 0, hy = 0, on = false, raf = null;
    var loop = function(){
      hx += (tx - hx) * 0.12; hy += (ty - hy) * 0.12;
      halo.style.transform = 'translate3d(' + hx.toFixed(1) + 'px,' + hy.toFixed(1) + 'px,0)';
      dot.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0)' + (overLink ? ' scale(2.2)' : '');
      if (Math.abs(tx - hx) > 0.3 || Math.abs(ty - hy) > 0.3) raf = requestAnimationFrame(loop); else raf = null;
    };
    var overLink = false;
    document.addEventListener('mousemove', function(ev){
      tx = ev.clientX; ty = ev.clientY;
      if (!on) { on = true; halo.classList.add('is-on'); dot.classList.add('is-on'); hx = tx; hy = ty; }
      overLink = !!(ev.target.closest && ev.target.closest('a, button, input, select, textarea, label'));
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: true });
    document.addEventListener('mouseleave', function(){ on = false; halo.classList.remove('is-on'); dot.classList.remove('is-on'); });
  }

  /* ---------- 5. particules du héros (canvas léger, en pause hors écran) ---------- */
  function particles(){
    if (!desktop) return;
    var hero = document.querySelector('.uh-hero'); if (!hero) return;
    var cv = document.createElement('canvas'); cv.className = 'rt-fx-canvas'; cv.setAttribute('aria-hidden', 'true'); hero.appendChild(cv);
    var ctx = cv.getContext('2d'), W = 0, H = 0, pts = [], running = false, raf = null, mx = -9999, my = -9999;
    var N = 42;
    var resize = function(){ W = cv.width = hero.clientWidth; H = cv.height = hero.clientHeight; };
    var seed = function(){ pts = []; for (var i = 0; i < N; i++) pts.push({ x: Math.random() * W, y: Math.random() * H, vx: (Math.random() - .5) * .25, vy: -(.15 + Math.random() * .35), r: 1 + Math.random() * 1.8, a: .25 + Math.random() * .5, g: Math.random() < .18 }); };
    var odd = false;
    var frame = function(){
      if (!running) return;
      if (document.documentElement.classList.contains('rt-fx-lite')) { stop(); return; }
      odd = !odd; if (odd) { raf = requestAnimationFrame(frame); return; }
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < pts.length; i++) {
        var p = pts[i]; p.x += p.vx; p.y += p.vy;
        var dx = mx - p.x, dy = my - p.y, d2 = dx * dx + dy * dy;
        if (d2 < 36000) { p.x -= dx * 0.004; p.y -= dy * 0.004; }
        if (p.y < -10) { p.y = H + 10; p.x = Math.random() * W; }
        if (p.x < -10) p.x = W + 10; if (p.x > W + 10) p.x = -10;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283);
        ctx.fillStyle = p.g ? 'rgba(6,193,103,' + p.a + ')' : 'rgba(213,29,25,' + p.a + ')'; ctx.fill();
        for (var j = i + 1; j < pts.length; j++) {
          var q = pts[j], ddx = p.x - q.x, ddy = p.y - q.y, dd = ddx * ddx + ddy * ddy;
          if (dd < 12100) { ctx.strokeStyle = 'rgba(213,29,25,' + (0.14 * (1 - dd / 12100)).toFixed(3) + ')'; ctx.lineWidth = 1; ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(q.x, q.y); ctx.stroke(); }
        }
      }
      raf = requestAnimationFrame(frame);
    };
    var start = function(){ if (running || document.hidden) return; running = true; raf = requestAnimationFrame(frame); };
    var stop = function(){ running = false; if (raf) cancelAnimationFrame(raf); raf = null; };
    resize(); seed();
    window.addEventListener('resize', function(){ resize(); seed(); });
    hero.addEventListener('mousemove', function(ev){ var r = cv.getBoundingClientRect(); mx = ev.clientX - r.left; my = ev.clientY - r.top; });
    hero.addEventListener('mouseleave', function(){ mx = my = -9999; });
    document.addEventListener('visibilitychange', function(){ if (document.hidden) stop(); else if (visible) start(); });
    var visible = true;
    if (hasIO) { new IntersectionObserver(function(es){ visible = es[0].isIntersecting; if (visible) start(); else stop(); }, { threshold: 0 }).observe(hero); } else start();
  }

  /* ---------- 6. étincelles du cockpit ---------- */
  function sparks(){
    if (!desktop) return;
    var sec = document.querySelector('#accompagnement'); if (!sec) return;
    for (var i = 0; i < 16; i++) {
      var s = document.createElement('i'); s.className = 'rt-fx-spark'; s.setAttribute('aria-hidden', 'true');
      s.style.left = (3 + Math.random() * 94).toFixed(1) + '%';
      s.style.animationDuration = (7 + Math.random() * 9).toFixed(1) + 's';
      s.style.animationDelay = (-Math.random() * 14).toFixed(1) + 's';
      s.style.opacity = (0.4 + Math.random() * 0.5).toFixed(2);
      sec.appendChild(s);
    }
  }

  /* ---------- 6b. néon « une fois » au scroll (v4) : un tour de lumière à l'apparition, puis liseré fixe ---------- */
  function neonOnce(){
    $('#faq summary').forEach(function(s){ var d = s.parentNode, off = Math.round(s.getBoundingClientRect().top - d.getBoundingClientRect().top); s.style.setProperty('--lt', (-off - 1) + 'px'); s.classList.add('rt-fx-line--once'); });
    $('.rt-case, .rt-step, #accompagnement .rt-dashboard-frame, .uh-chip, .rt-article-body .rt-callout, .rt-article-body figure').forEach(function(el){
      if (el.classList.contains('rt-fx-neon')) return;
      el.classList.add('rt-fx-neon--once');
      var ring = document.createElement('i'); ring.className = 'rt-fx-neon__ring'; ring.setAttribute('aria-hidden', 'true'); ring.appendChild(document.createElement('b')); el.appendChild(ring);
    });
  }

  /* ---------- 6c. rayon de lumière qui parcourt le rail de la méthode (v4) ---------- */
  function beam(){
    var g = document.querySelector('.rt-method-grid'); if (!g) return;
    var b = document.createElement('i'); b.className = 'rt-fx-beam'; b.setAttribute('aria-hidden', 'true'); g.appendChild(b);
  }

  /* ---------- 6d. en-tête : ombre quand on a quitté le haut de page (v4) ---------- */
  function headerScroll(){
    var last = null;
    var tick = function(){ var s = window.scrollY > 40; if (s !== last) { last = s; document.documentElement.classList.toggle('rt-fx-scrolled', s); } };
    window.addEventListener('scroll', tick, { passive: true }); tick();
  }

  /* ---------- 7. barre de progression de lecture (articles) ---------- */
  function progress(){
    var body = document.querySelector('.rt-article-body'); if (!body) return;
    var bar = document.createElement('div'); bar.className = 'rt-fx-progress'; bar.setAttribute('aria-hidden', 'true');
    var fill = document.createElement('i'); bar.appendChild(fill); document.body.appendChild(bar);
    var tick = function(){
      var r = body.getBoundingClientRect(), total = r.height - window.innerHeight * 0.6;
      var done = Math.min(Math.max(-r.top + window.innerHeight * 0.2, 0), Math.max(total, 1));
      fill.style.width = (total > 0 ? (done / total) * 100 : 0).toFixed(1) + '%';
    };
    window.addEventListener('scroll', tick, { passive: true }); window.addEventListener('resize', tick); tick();
  }

  function init(){ reveal(); tilts(); cursor(); progress(); neonOnce(); beam(); headerScroll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ===================== v3 : souris « encore mieux », profondeur, radar, chargement ===================== */
(function(){
  'use strict';
  var mq = function(q){ return window.matchMedia && window.matchMedia(q).matches; };
  if (mq('(prefers-reduced-motion: reduce)')) return;
  var desktop = mq('(min-width: 760px)'), fine = mq('(pointer: fine)');
  var $ = function(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* barre de chargement */
  function loader(){
    var l = document.createElement('div'); l.className = 'rt-fx-load'; l.setAttribute('aria-hidden', 'true'); document.body.appendChild(l);
    var done = function(){ l.classList.add('is-done'); setTimeout(function(){ if (l.parentNode) l.parentNode.removeChild(l); }, 900); };
    if (document.readyState === 'complete') setTimeout(done, 900); else window.addEventListener('load', function(){ setTimeout(done, 500); });
  }

  /* reflet qui suit la souris sur les cartes */
  function glare(){
    if (!desktop || !fine) return;
    $('.rt-case, .rt-step, .rt-proofline__card, .rt-founder__card, .rt-form, #accompagnement .rt-dashboard-frame, .uh-collage2 .uh-c, .rt-related-card').forEach(function(el){
      el.classList.add('rt-fx-glare');
      var w = document.createElement('i'); w.className = 'rt-fx-glare__w'; w.setAttribute('aria-hidden', 'true'); var dot = document.createElement('b'); w.appendChild(dot); el.appendChild(w);
      var rect = null, raf = null, lx = 0, ly = 0;
      el.addEventListener('mouseenter', function(){ rect = el.getBoundingClientRect(); });
      el.addEventListener('mousemove', function(ev){ lx = ev.clientX; ly = ev.clientY; if (!raf) raf = requestAnimationFrame(function(){ raf = null; if (!rect) rect = el.getBoundingClientRect(); dot.style.transform = 'translate3d(' + (lx - rect.left).toFixed(1) + 'px,' + (ly - rect.top).toFixed(1) + 'px,0)'; }); }, { passive: true });
    });
  }

  /* boutons magnétiques : ils viennent vers la souris */
  function magnetic(){
    if (!desktop || !fine) return;
    var btns = $('.uh-btn, .rt-button, .rtbtn, .rt-cta-inline, .rt-art-cta .btn, .rt-founder__link');
    var raf = null, mx = 0, my = 0, rects = [], lastMeasure = 0;
    var tick = function(){
      raf = null;
      var now = performance.now();
      if (now - lastMeasure > 150) { lastMeasure = now; rects = btns.map(function(b){ return b.getBoundingClientRect(); }); }
      btns.forEach(function(b, i){
        var r = rects[i]; if (!r) return;
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var cx = r.left + r.width / 2, cy = r.top + r.height / 2, dx = mx - cx, dy = my - cy, d = Math.sqrt(dx * dx + dy * dy), R = Math.max(r.width, 120);
        if (d < R) { var k = (1 - d / R) * 0.35; b.style.transform = 'translate(' + (dx * k).toFixed(1) + 'px,' + (dy * k).toFixed(1) + 'px) scale(1.03)'; b.setAttribute('data-fx-mag', '1'); }
        else if (b.getAttribute('data-fx-mag')) { b.style.transform = ''; b.removeAttribute('data-fx-mag'); }
      });
    };
    document.addEventListener('mousemove', function(ev){ mx = ev.clientX; my = ev.clientY; if (!raf) raf = requestAnimationFrame(tick); }, { passive: true });
  }

  /* anneau + traînée de comète + éclat au clic */
  function cursor2(){
    if (!desktop || !fine) return;
    var ring = document.createElement('div'); ring.className = 'rt-fx-ring'; ring.style.display = 'none'; /* anneau retiré le 10/10 15h08 (retour Mathieu) */
    var trail = []; for (var i = 0; i < 0; i++) { var t = document.createElement('i'); t.className = 'rt-fx-trail'; t.style.opacity = (0.55 - i * 0.06).toFixed(2); t.style.transform = 'scale(' + (1 - i * 0.07).toFixed(2) + ')'; document.body.appendChild(t); trail.push({ el: t, x: 0, y: 0 }); }
    var tx = 0, ty = 0, rx = 0, ry = 0, on = false, raf = null, dot = document.querySelector('.rt-fx-dot');
    var loop = function(){
      rx += (tx - rx) * 0.2; ry += (ty - ry) * 0.2;
      ring.style.transform = 'translate3d(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px,0)';
      var px = tx, py = ty, moving = false;
      for (var i = 0; i < trail.length; i++) { var p = trail[i]; p.x += (px - p.x) * 0.35; p.y += (py - p.y) * 0.35; p.el.style.transform = 'translate3d(' + p.x.toFixed(1) + 'px,' + p.y.toFixed(1) + 'px,0) scale(' + (1 - i * 0.07).toFixed(2) + ')'; if (Math.abs(px - p.x) > 0.4 || Math.abs(py - p.y) > 0.4) moving = true; px = p.x; py = p.y; }
      if (moving || Math.abs(tx - rx) > 0.3 || Math.abs(ty - ry) > 0.3) raf = requestAnimationFrame(loop); else raf = null;
    };
    document.addEventListener('mousemove', function(ev){
      tx = ev.clientX; ty = ev.clientY;
      if (!on) { on = true; ring.classList.add('is-on'); rx = tx; ry = ty; trail.forEach(function(p){ p.x = tx; p.y = ty; }); }
      var t = ev.target, link = !!(t.closest && t.closest('a, button, input, select, textarea, label, .uh-c, .rt-case'));
      var green = !!(t.closest && t.closest('.uh-ue'));
      ring.classList.toggle('is-link', link); ring.classList.toggle('is-green', green); if (dot) dot.classList.toggle('is-green', green);
      trail.forEach(function(p){ p.el.style.opacity = link ? '0' : ''; });
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: true });
    document.addEventListener('mouseleave', function(){ on = false; ring.classList.remove('is-on'); });
    document.addEventListener('mousedown', function(ev){
      var r = document.createElement('i'); r.className = 'rt-fx-ringout'; r.style.left = ev.clientX + 'px'; r.style.top = ev.clientY + 'px'; document.body.appendChild(r);
      for (var i = 0; i < 10; i++) { var a = (Math.PI * 2 / 10) * i + Math.random() * .5, d = 40 + Math.random() * 50; var s = document.createElement('i'); s.className = 'rt-fx-burst'; s.style.left = ev.clientX + 'px'; s.style.top = ev.clientY + 'px'; s.style.background = i % 4 === 0 ? '#06c167' : '#d51d19'; s.style.setProperty('--dx', (Math.cos(a) * d).toFixed(0) + 'px'); s.style.setProperty('--dy', (Math.sin(a) * d).toFixed(0) + 'px'); document.body.appendChild(s); }
      setTimeout(function(){ $('.rt-fx-burst, .rt-fx-ringout').forEach(function(e){ if (e.parentNode) e.parentNode.removeChild(e); }); }, 800);
    });
  }

  /* profondeur du héros : grille, halos et collage réagissent à la souris */
  function heroDepth(){
    if (!desktop || !fine) return;
    var hero = document.querySelector('.uh-hero'); if (!hero) return;
    var col = document.querySelector('.uh-collage2');
    hero.addEventListener('mousemove', function(ev){
      var r = hero.getBoundingClientRect(), x = (ev.clientX - r.left) / r.width - 0.5, y = (ev.clientY - r.top) / r.height - 0.5;
      hero.style.setProperty('--mx', (x * 2).toFixed(3)); hero.style.setProperty('--my', (y * 2).toFixed(3)); hero.style.setProperty('--mi', '1');
      if (col) col.style.transform = 'perspective(1400px) rotateX(' + (-y * 10).toFixed(2) + 'deg) rotateY(' + (x * 14).toFixed(2) + 'deg) translate3d(' + (x * 26).toFixed(1) + 'px,' + (y * 18).toFixed(1) + 'px,10px)';
    });
    hero.addEventListener('mouseleave', function(){ hero.style.setProperty('--mx', '0'); hero.style.setProperty('--my', '0'); hero.style.setProperty('--mi', '0'); if (col) col.style.transform = ''; });
  }

  /* radar de navigation à droite (accueil) */
  function radar(){
    if (!desktop) return;
    var secs = $('#resultats, #avant-apres, #accompagnement, #methode, #faq, #audit'); if (secs.length < 3) return;
    var labels = { resultats: 'Résultats', 'avant-apres': 'Avant / Après', accompagnement: 'Dashboard', methode: 'Méthode', faq: 'FAQ', audit: 'Audit gratuit' };
    var nav = document.createElement('nav'); nav.className = 'rt-fx-radar'; nav.setAttribute('aria-label', 'Sections de la page');
    var links = {};
    secs.forEach(function(s){ var a = document.createElement('a'); a.href = '#' + s.id; a.setAttribute('data-label', labels[s.id] || s.id); a.setAttribute('aria-label', labels[s.id] || s.id); nav.appendChild(a); links[s.id] = a; });
    document.body.appendChild(nav);
    var dark = { accompagnement: true, audit: true };
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) { Object.keys(links).forEach(function(k){ links[k].classList.toggle('is-active', k === e.target.id); }); nav.classList.toggle('is-dark', !!dark[e.target.id]); } }); }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    secs.forEach(function(s){ io.observe(s); });
    window.addEventListener('scroll', function(){ nav.classList.toggle('is-on', window.scrollY > 300); }, { passive: true });
  }

  /* sonde de fluidité : si la machine rend moins de 40 images/s pendant 1,5 s après le chargement, on coupe les couches lourdes */
  function probe(){
    if (!desktop) return;
    var t0 = 0, n = 0, slow = 0, last = 0;
    var tick = function(ts){
      if (!t0) { t0 = ts; last = ts; requestAnimationFrame(tick); return; }
      var dt = ts - last; last = ts; n++; if (dt > 25) slow++;
      if (ts - t0 < 1500) { requestAnimationFrame(tick); return; }
      if (n > 10 && slow / n > 0.5) document.documentElement.classList.add('rt-fx-lite');
    };
    var go = function(){ setTimeout(function(){ requestAnimationFrame(tick); }, 1200); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
  }

  function init(){ loader(); glare(); cursor2(); heroDepth(); radar(); probe(); } /* magnetic() retiré le 10/10 (retour Mathieu) */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
